import _ from 'lodash';
import moment from 'moment';
import BaseAccountController from '../../lib/controllers/BaseAccountController';

declare var LtFramework: lt.Static;

interface IResourceKeyEx extends MyAccountApi.IResourceKey {
	sortDate: Date; // JS Date representation used for sorting purposes
	startDate: string; // Start date string for api call
	endDate: string; // End date string for api call
	visitsRemaining: number; // number of visits remaining
}

export default class DayPassHistoryController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'Profile', 'UserResource', 'ResourceKeyResource'];

	public user: MyAccountApi.IUser;
	public dayPassResources: MyAccountApi.IResourceKey[] = [];

	private readonly User: MyAccountApi.IUserResource;
	private readonly ResourceKey: MyAccountApi.IResourceKeyResource;

	constructor($scope: ng.IScope, Profile: lt.IProfile, User: MyAccountApi.IUserResource, ResourceKey: MyAccountApi.IResourceKeyResource) {
		super($scope, Profile);

		this.User = User;
		this.ResourceKey = ResourceKey;
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		// load My Account user details
		this.user = this.User.get();

		// load day pass information
		this.ResourceKey.get({include_expired: true, include_resources: true}, this.loadDayPasses.bind(this));
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private loadDayPasses(resourceKeys: MyAccountApi.IResourceKey[]): void {
		this.dayPassResources = resourceKeys;
		// filter out the dayPass-specific resources from the profile
		this.dayPassResources = _.filter(this.dayPassResources, (o: MyAccountApi.IResourceKey) => {
			return (o.identifier.indexOf('DayPass') > -1);
		});
		// modify the dates properties
		_.forEach(this.dayPassResources, (o: MyAccountApi.IResourceKey) => {
			// format the date display
			o.fromDate = moment(o.fromDate).format('MMM D, YYYY');
			o.thruDate = moment(o.thruDate).format('MMM D, YYYY');
			// set date property for sorting purposes
			(o as IResourceKeyEx).sortDate = moment(o.fromDate, 'YYYY-MM-DD').toDate();
			// set date strings for detail/club visits call
			(o as IResourceKeyEx).startDate = moment(o.fromDate).format('YYYY-MM-DD');
			(o as IResourceKeyEx).endDate = moment().format('YYYY-MM-DD');
			// set visits remaining property
			(o as IResourceKeyEx).visitsRemaining = o.usageLimit - o.usageCount;
		});
		LtFramework.actions.bindPartnerUrls();
	}
}
